import React, { createContext, useState } from "react";

const UrlServicesContext = createContext();
const { Provider, Consumer } = UrlServicesContext;

function UrlServicesProvider({ children }) {
  /* ### URL ### */
  /*const [urlServices] = useState('http://localhost:3001/')
  const [urlWeb] = useState('http://localhost:3000/')*/

  /*const [urlServices] = useState('http://192.168.100.13:3000/')
  const [urlWeb] = useState('http://192.168.100.13:3001/')*/

  const [urlServices] = useState("https://api.psicometricosecuador.com/");
  const [urlWeb] = useState("https://web.psicometricosecuador.com/");

  /* ### PROFILE ### */
  const [urlLocalMediaProfile] = useState(
    "https://web.psicometricosecuador.com/files/",
  );

  /* ### LOAD SERVICES KEYAPLICATION */
  const [keyAplication] = useState("oagLwwkQAx2e6mHEKjL8");

  return (
    <Provider
      value={{
        urlServices,
        urlLocalMediaProfile,
        keyAplication,
        urlWeb,
      }}
    >
      {children}
    </Provider>
  );
}

export {
  UrlServicesProvider,
  Consumer as urlServicesConsumer,
  UrlServicesContext,
};
